import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalTitle: {
    id: 'frontbucket.createJiraWorkItemModal.modalTitle',
    description:
      'Default title for the modal that creates a Jira work item from a Bitbucket context',
    defaultMessage: 'Create Jira work item',
  },
  successTitle: {
    id: 'frontbucket.createJiraWorkItemModal.successTitle',
    description:
      'Title of the success flag shown after a Jira work item is successfully created',
    defaultMessage: "You've created {workItemKey} work item",
  },
  errorTitle: {
    id: 'frontbucket.createJiraWorkItemModal.errorTitle',
    description:
      'Title of the error flag shown when Jira work item creation fails',
    defaultMessage: "We couldn't create the Jira work item",
  },
  errorDescription: {
    id: 'frontbucket.createJiraWorkItemModal.errorDescription',
    description:
      'Description of the error flag shown when Jira work item creation fails',
    defaultMessage: 'Refresh and try again.',
  },
});
